// delLists/approvalLists/actions.js

import { getDelLists } from "../../../api/DelApi";
import { approvalsInitialState } from "./delListsApprovalListsState";
import { filtersInitialState } from "../../shared/filters/filtersState";
export const makeApprovalsActions = (set, get) => ({
  setApprovalsPage: ({ currentPage, pageSize }) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approvals: { ...s.delLists.approvals, currentPage, pageSize },
      },
    })),

  setApprovalsPageSize: (pageSize) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approvals: { ...s.delLists.approvals, pageSize, currentPage: 1 },
      },
    })),

  setSelectedApproval: (approval) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approvals: { ...s.delLists.approvals, selectedApproval: approval },
      },
    })),

  removeApprovalLocal: (delId) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approvals: {
          ...s.delLists.approvals,
          items: s.delLists.approvals.items.filter((d) => d.id !== delId),
        },
      },
    })),

  resetApprovals: () =>
    set((s) => ({
      delLists: { ...s.delLists, approvals: approvalsInitialState },
    })),

  fetchApprovalsPage: async (employeeId, overrideFilters) => {
    const {
      delLists: {
        approvals: { currentPage, pageSize, filters, tableType },
      },
    } = get();
    const activeFilters = overrideFilters || filters || filtersInitialState();

    set((s) => ({
      delLists: {
        ...s.delLists,
        approvals: { ...s.delLists.approvals, loading: true, error: null },
      },
    }));

    try {
      const r = await getDelLists(
        employeeId,
        tableType,
        currentPage,
        pageSize,
        activeFilters
      );
      set((s) => ({
        delLists: {
          ...s.delLists,
          approvals: {
            ...s.delLists.approvals,
            loading: false,
            items: r.del_list,
            totalCount: r.total_count,
            needsUpdate: false,
            selectedApproval: null,
          },
        },
      }));
    } catch (err) {
      console.error("Failed to fetch approvals page:", err);
      set((s) => ({
        delLists: {
          ...s.delLists,
          approvals: {
            ...s.delLists.approvals,
            loading: false,
            error: err.message,
          },
        },
      }));
    }
  },
});
